import { useEffect, useState } from 'react';
import { Spinner } from '@Components/Spinner';
import { CpsMonthReportStats } from './cps-utils';
import { FinanceReportSection } from './FinanceReportSection';
import { SalesforceResyncSection } from './SalesforceResyncSection';
import { awaitJSON, ClientToolsLambdaFetch } from '../../utils/fetch-utils';
import { useSetError } from '../../redux/modals';

const AdminTab = () => {
  const setError = useSetError();
  const [stats, setStats] = useState<CpsMonthReportStats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await ClientToolsLambdaFetch('/cps/monthReportStats');
        const data = await awaitJSON<CpsMonthReportStats>(res);
        setStats(data);
      } catch (e) {
        setError({ message: `Failed to load survey stats: ${e.message}`, reportError: e });
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, [setError]);

  if (loading) return <Spinner />;

  return (
    <div className='cps-admin-tab'>
      <FinanceReportSection stats={stats} />
      <SalesforceResyncSection />
    </div>
  );
};

export { AdminTab };
